<template lang="pug">
#login
    router-link(to="/")
        img(src="@/assets/img/logo/symbol-logo.png" alt="Skapi Logo" style="width: 40px; margin-bottom: .625rem")

    .page-title Login

    hr

    form(@submit.prevent="login" style='padding-bottom: 0;')
        label
            | Email
            input.block(type="email" @input="e=> { form.email = e.target.value; error='';}" :disabled="promiseRunning" placeholder="your@email.com" required)

        label.passwordInput
            | Password
            input.block(:type='showPassword ? "text" : "password"'
            @input="(e)=>{form.password = e.target.value; error='';}" 
            :disabled="promiseRunning"
            name="password" placeholder="Enter password" required)
            //- .passwordIcon(@click.stop="showPassword = !showPassword")
            //-     template(v-if="showPassword")
            //-         svg.svgIcon(style="fill: var(--black-6)")
            //-             use(xlink:href="/material-icon.svg?v=20250829065753667#icon-visibility-fill")
            //-     template(v-else)
            //-         svg.svgIcon(style="fill: var(--black-6)")
            //-             use(xlink:href="/material-icon.svg?v=20250829065753667#icon-visibility-off-fill")

        .actions
            Checkbox(style='font-weight:unset;' @change="(e)=>{setLocalStorage(e)}" :disabled='promiseRunning' v-model='remVal') Remember Me
            RouterLink(to="/forgot" :class='{disabled: promiseRunning}') Forgot Password?

        br

        .error(v-if="openIdLoginError || error")
            svg
                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-error")
            div(v-if="enableAccount")
                | {{ error }}
                br
                br
            span(v-else) {{ openIdLoginError|| error }}

        .error(v-if="enableAccount" style="align-items: center;")
            router-link(:to='"/enable-account/" + form.email') [Click Here]
            span &nbsp;to enable your account.

        br

        .bottom(style="height: 52px")
            div(v-if="promiseRunning" style="width:100%; text-align:center")
                .loader(style="--loader-color:white; --loader-size:12px")
            template(v-else)
                button.inline.btn-login(type="submit" data-track="login_login") Login
                .signup
                    span.text No account?&nbsp;
                    template(v-if="route.query.action")
                        RouterLink(data-track="login_signUp" :to="{ name: 'signup', query: { action: route.query.action } }") Sign up
                    template(v-else-if="route.query.refer")
                        RouterLink(data-track="login_signUp" :to="{ name: 'signup', query: { refer: route.query.refer } }") Sign up
                    template(v-else)
                        RouterLink(data-track="login_signUp" :to="{ name: 'signup' }") Sign up
                    //- router-link.btn-signup(:to="route.query.refer_name ? { name: 'signup', query: { suc_redirect: '/refer/' + route.query.refer_name } } : { name: 'signup' }") Sign up

    .or-divider
        .or-line
        .or-text OR
        .or-line

    button.gsi-material-button(style="width:440px" data-track="login_googleLogin" @click="e=>googleLogin(e,'login_googleLogin')" :disabled="promiseRunning")
        .gsi-material-button-state
        .gsi-material-button-content-wrapper
            .gsi-material-button-icon
                svg(version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;")
                    path(fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z")
                    path(fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z")
                    path(fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z")
                    path(fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z")
                    path(fill="none" d="M0 0h48v48H0z")
            span.gsi-material-button-contents Continue with Google
            span(style="display: none;") Continue with Google

Modal.modal-enableAccount(:open="enableAccount")
    .modal-container
        .modal-header
            .modal-title Enable Account
        .modal-body
            .modal-desc.
                Your account is disabled.
                #[br]
                Please contact support to enable your account.
                #[br]
                You can also try resetting your password.
        .modal-footer
            .modal-btns
                button.gray.btn-cancel(type="button" @click="enableAccount = false") Cancel
                button.block.btn-enable(type="button" data-track="login_enableAccount" @click="router.push('/enable-account/' + form.email)") Enable
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { skapi, openIdLoginError } from "@/main";
import { user } from "@/code/user";
import { onMounted, ref, onBeforeMount } from "vue";
import { type PublicUser } from "./service";

import Checkbox from "@/components/checkbox.vue";
import Modal from "@/components/modal.vue";
import { googleLogin } from "@/code/user";
import { SkapiError } from "skapi-js";

const router = useRouter();
const route = useRoute();

let showPassword = ref(false);
let remVal = ref(false); // dom 업데이트시 checkbox value 유지하기 위함
let promiseRunning = ref(false);
let error = ref(null);
let form = {
    email: "",
    password: "",
};
let enableAccount = ref(false);

onMounted(() => {
    if (user.user_id) {
        router.push("/my-services");
    }

    if (window.localStorage.getItem("dont_remember") === "true") {
        remVal.value = false;
    } else {
        remVal.value = true;
    }
});
let setLocalStorage = (e) => {
    localStorage.setItem("dont_remember", e.target.checked ? "false" : "true");
};

let login = (e) => {
    promiseRunning.value = true;

    let params = {
        email: form.email,
        password: form.password,
    };

    skapi
        .login(params)
        .then(async (u) => {
            let routerQuery = route.query || {};
            if (Object.keys(routerQuery).length) {
                if (routerQuery.action) {
                    router
                        .push({
                            path: "/my-services",
                            query: { action: routerQuery.action },
                        })
                        .then(() => {
                            promiseRunning.value = false;
                        });
                } else if (routerQuery.refer) {
                    router
                        .push({ name: "refer", params: { name: routerQuery.refer } })
                        .then(() => {
                            promiseRunning.value = false;
                        });
                } else if (routerQuery.redirect) {
                    if (routerQuery.rdp && routerQuery.sid) {
                        router
                            .push({ name: Array.isArray(routerQuery.rdp) ? routerQuery.rdp[0] : routerQuery.rdp, params: { service: routerQuery.sid } })
                            .then(() => {
                                promiseRunning.value = false;
                            });
                    }
                }
            } else {
                router.push("/my-services").then(() => {
                    promiseRunning.value = false;
                });
            }
        })
        .catch((err) => {
            if (!(err instanceof SkapiError)) throw err;

            if (err.code === "SIGNUP_CONFIRMATION_NEEDED") {
                router.push({
                    path: "/confirmation",
                    query: { email: form.email },
                });
            } else if (err.code === "USER_IS_DISABLED") {
                error.value = "This account is disabled.";
                enableAccount.value = true;
            } else if (err.code === "INCORRECT_USERNAME_OR_PASSWORD") {
                error.value = "Incorrect email or password.";
            } else if (err.code === "NOT_EXISTS") {
                error.value = "Incorrect email or password.";
            } else {
                error.value = err.message;
            }

            promiseRunning.value = false;

        });
};

</script>

<style scoped lang="less">
#login {
    max-width: 480px;
    padding: 5rem 20px;
    margin: 0 auto;
    width: 100%;
}

form {
    padding: 8px;

    >label {
        margin-bottom: 16px;
    }

    .actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }

    .bottom {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        flex-direction: row-reverse;
        min-height: 44px;

        .signup {
            font-size: 16px;
            margin: 16px 0;
        }
    }
}

.btn-signup {
    display: inline-block;
    margin-left: 0.5rem;
}

.btn-login {
    padding: 0.875rem 1.5rem;
}

@media (max-width: 480px) {
    form {
        padding-bottom: 1rem;

        .bottom {
            display: block;
            text-align: center;

            button {
                width: 100%;
                max-width: 100%;
            }

            .forgot {
                display: block;
                margin-bottom: 8px;
            }
        }
    }
}
</style>
